import { HTMLAttributes, FC } from "react";
import clsx from "classnames";
import { Button } from "../../core/Button/Button";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { useStyles } from "./FeaturedConsole.style";
import { useNavigate } from "react-router-dom";
import { StaticImage } from "../../core/StaticImage/StaticImage";
import { FeaturedCard } from "@onmo/graphql/graphql";
import { getFeaturedCardData } from "../../../models/console";
import { AnalyticsGA4 } from "../../../models/analyticsGA4";
import { useTranslation } from "react-i18next";

interface IFeaturedConsoleProps extends HTMLAttributes<HTMLDivElement> {
  data: FeaturedCard;
}

export const FeaturedConsole: FC<IFeaturedConsoleProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { className, data, ...othersProps } = props;
  const { title, assets, description, internalPath } =
    getFeaturedCardData(data);

  const handleEssentialPass = () => {
    AnalyticsGA4.homepageAction("essential_pass");
    navigate(internalPath);
  };

  return (
    <div
      {...othersProps}
      className={clsx(classes.root, className)}
      data-gamepad="featured-card"
      role="button"
      tabIndex={-1}
      data-selected-class={classes.selected}
      onClick={handleEssentialPass}
    >
      <StaticImage
        alt=""
        src={assets?.image1X}
        src2x={assets?.image2X}
        src3x={assets?.image3X}
        className={classes.featuredImg}
      />
      <div className={classes.content}>
        <Typography variant={TypographyVariant.HeadingH5Bold}>
          {title}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB3Regular}
          className={classes.desc}
        >
          {description}
        </Typography>
        <Button
          variant="outlined"
          className={classes.btnAction}
          disableGamepadAction
          aria-hidden
          tabIndex={-1}
        >
          {t("Console_Explore")}
        </Button>
      </div>
    </div>
  );
};
